import { useAuth } from "./AuthContext";
import styles from "./RemoteSessionBanner.module.css";

export default function RemoteSessionBanner() {
  const { remoteSessionStatus } = useAuth();

  // "loading" est le bootstrap normal au demarrage (avant le tout premier
  // essai) : ne doit rien afficher, sinon le bandeau "degrade" clignote a
  // chaque connexion meme quand tout fonctionne. Seuls "recovering" (un
  // essai a deja echoue, nouvelle tentative en cours) et "degraded" (tous
  // les essais ont echoue) signalent un vrai probleme a l'utilisateur.
  if (remoteSessionStatus === "ok" || remoteSessionStatus === "idle" || remoteSessionStatus === "loading") {
    return null;
  }

  const isRecovering = remoteSessionStatus === "recovering";

  return (
    <div
      className={`${styles.banner} ${isRecovering ? styles.bannerRecovering : styles.bannerDegraded}`}
      role="status"
      aria-live="polite"
    >
      <span className={styles.icon}>{isRecovering ? "⟳" : "!"}</span>
      <span className={styles.message}>
        {isRecovering
          ? "Reconnexion au serveur en cours..."
          : "Certaines fonctionnalites peuvent etre indisponibles. Rechargez la page ou reconnectez-vous."}
      </span>
    </div>
  );
}
